import {createContext} from "react";
import {Theme, ViewGroup} from "./useApplicationConfigs";
import {Language} from "../models/language";
import {Notification} from "../notification/useNotification";
import {defaultNotificationState, NotificationState} from "../notification/notificationState";

interface ApplicationConfigsContextInterface {
  language: Language;
  changeLanguage: (language: Language) => void;
  viewGroups: ViewGroup,
  handleViewGroups: (viewGroup: ViewGroup) => void;
  changeTheme: () => void;
  clearNotifications: () => void;
  theme: Theme;
  notifications: Notification[];
  notificationState: NotificationState;
}

export const defaultApplicationConfigsContext: ApplicationConfigsContextInterface = {
  language: Language.English,
  changeLanguage: () => void 0,
  viewGroups: 'list',
  handleViewGroups: () => void 0,
  theme: "light",
  changeTheme: () => void 0,
  clearNotifications: () => void 0,
  notifications: [],
  notificationState: defaultNotificationState
};

export const ApplicationConfigsContext = createContext(defaultApplicationConfigsContext);
